/**
 * @generated SignedSource<<d459fce10f05a254e3cac2fbda3eee38>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ZnglyInfo_Settings_Fragment$data = {
  readonly znglyInfo: {
    readonly id: string;
    readonly znglyInfo: {
      readonly " $fragmentSpreads": FragmentRefs<"analytics_Settings_Fragment" | "backend_Settings_Fragment" | "body_Settings_Fragment" | "footer_Settings_Fragment" | "globalStyles_Settings_Fragment" | "header_Settings_Fragment" | "homePage_Settings_Fragment" | "integrations_Settings_Fragment" | "personalisedVideo_Settings_Fragment" | "privacyPolicy_Settings_Fragment" | "qrCodeTab_Settings_Fragment" | "siteSettings_Settings_Fragment">;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ZnglyInfo_Settings_Fragment";
};
export type ZnglyInfo_Settings_Fragment$key = {
  readonly " $data"?: ZnglyInfo_Settings_Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ZnglyInfo_Settings_Fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ZnglyInfo_Settings_Fragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "id",
          "value": "site-info"
        },
        {
          "kind": "Literal",
          "name": "idType",
          "value": "SLUG"
        }
      ],
      "concreteType": "ZnglyInfo",
      "kind": "LinkedField",
      "name": "znglyInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ZnglyInfo_Znglyinfo",
          "kind": "LinkedField",
          "name": "znglyInfo",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "integrations_Settings_Fragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "analytics_Settings_Fragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "privacyPolicy_Settings_Fragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "siteSettings_Settings_Fragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "globalStyles_Settings_Fragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "qrCodeTab_Settings_Fragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "backend_Settings_Fragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "personalisedVideo_Settings_Fragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "header_Settings_Fragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "body_Settings_Fragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "footer_Settings_Fragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "homePage_Settings_Fragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "znglyInfo(id:\"site-info\",idType:\"SLUG\")"
    }
  ],
  "type": "RootQuery",
  "abstractKey": null
};

(node as any).hash = "ba1995bd17ec7a7b9154244a0d0f4510";

export default node;
